<template>
    <div class="block-content block-content-desglose">
        <h1 class="title desgloseTitle py-3">
            <span class="ml-3">Total</span>
        </h1>

        <load-spiner v-if="!linesCompositeByWeeks"></load-spiner>
        <div v-else class="desgloses_block row p-3">
            <div
                class="col-12 content_info"
                v-for="week in linesCompositeByWeeks"
            >
                <div class="row">
                    <div class="col-12 order_title pb-2" style="display: grid;">
                        <span
                            ><b>Pedido - Semana {{ week.week }}</b></span
                        >
                        <span style="font-size: 13px; font-weight: bold">{{
                            week.weekYear | subtitleEnvio
                        }}</span>
                    </div>
                    <div v-for="line in week.disponibleLines" class="col-12">
                        <div class="row mb-1">
                            <div class="col-9">
                                <span>
                                    {{ line.ecologico ? "ECO " : ""
                                    }}{{ line.articulo.nombre }} -
                                    {{ line.combinacion.bandeja.unidades }}x{{
                                        line.combinacion.semilla_alveolo
                                    }}</span
                                >
                                <img
                                    src="/img/logos/Logo-Euro-Agricultura.png"
                                    alt="Logo ECO"
                                    style="width: 20px"
                                    v-if="line.ecologico"
                                    title="Producto ecológico"
                                /><br />
                                <span>Nº de bandejas {{ line.unidades }}</span>
                            </div>
                            <div class="col-3 content_valores">
                                <span style="white-space: nowrap"
                                    >{{ line.total }} €</span
                                >
                            </div>
                        </div>
                    </div>
                    <div v-for="line in week.customLines" class="col-12">
                        <div class="row mb-1">
                            <div class="col-9">
                                <span>
                                    {{ line.ecologico ? "ECO " : ""
                                    }}{{ line.variety.nombre }} -
                                    {{ line.tray.unidades }}x{{
                                        line.seeds_by_alveolus
                                    }}</span
                                >
                                <img
                                    src="/img/logos/Logo-Euro-Agricultura.png"
                                    alt="Logo ECO"
                                    style="width: 20px"
                                    v-if="line.ecologico"
                                    title="Producto ecológico"
                                /><br />
                                <span>Nº de bandejas {{ line.num_trays }}</span>
                            </div>
                            <div class="col-3 content_valores">
                                <span style="white-space: nowrap"
                                    >{{ line.total_now }} €</span
                                >
                            </div>
                        </div>
                    </div>
                    <div v-if="week.recargo_e > 0" class="col-12">
                        <div class="row">
                            <div class="col-9">
                                <span>Recargo de equivalencia</span>
                            </div>
                            <div class="col-3 content_valores">
                                <span>{{ week.recargo_e }} €</span>
                            </div>
                        </div>
                    </div>
                    <div v-for="envio in week.envios" class="col-12">
                        <div v-if="!envio.share_ship_order_id" class="row">
                            <div class="col-9">
                                <span
                                    >Gastos
                                    {{
                                        envio.metodo_envio.transportista.nombre
                                    }}</span
                                >
                            </div>
                            <div class="col-3 content_valores">
                                <span v-if="envio.metodo_envio.precio > 0"
                                    >{{ envio.metodo_envio.precio }} €</span
                                >
                                <span v-else>GRATIS</span>
                            </div>
                            <div
                                v-if="
                                    envio.metodo_envio.precio > 0 &&
                                        (step == '1' || step == '2')
                                "
                                class="col-12 free-shipping"
                            >
                                <span
                                    class="cursor_pointer"
                                    @click="
                                        openInfoWindow(
                                            'gastos_gratis' + week.week
                                        )
                                    "
                                    >¿Gastos de envío gratis?</span
                                >
                                <windows-info
                                    v-cloak
                                    :ref="'gastos_gratis' + week.week"
                                    back-color="white"
                                    in-cart="false"
                                >
                                    <div slot="header">
                                        <p>
                                            <b>Ahorre los gastos de envío</b>
                                        </p>
                                        <p>
                                            Realice un pedído mínimo de 12
                                            bandejas por semana para eliminar
                                            los gastos de envío.
                                        </p>
                                        <p>
                                            Puede unificar todos los pedídos en
                                            una única semana.
                                        </p>
                                        <p>
                                            Añadir más cantidad de bandejas en
                                            la cesta o seleccionar entre las
                                            diferentes variedades del
                                            disponible.
                                        </p>
                                        <a href="/">
                                            <div
                                                class="btn-info-w cursor_pointer"
                                            >
                                                <span>Ir al disponible</span>
                                            </div>
                                        </a>
                                        <p>
                                            Pagarás el pedido en las
                                            instalaciones de Babyplant al
                                            retirar tu pedido.
                                        </p>
                                        <p>
                                            Ctra. Santomera - Alquerías, Km. 1 ·
                                            30140 Santomera, Murcia.<br />
                                            <a
                                                class="view_in_gmaps"
                                                href="https://goo.gl/maps/E5Z52uzVgUsL6uQ2A"
                                                target="_blank"
                                                >Ver en Google Maps</a
                                            >
                                        </p>
                                        <div
                                            class="btn-info-w-alt cursor_pointer mb-3"
                                            @click="
                                                setInstalaciones(
                                                    week.weekYear,
                                                    envio.id
                                                )
                                            "
                                        >
                                            <span>Recogida en Babyplant</span>
                                        </div>
                                        <p>
                                            Si conoces a otro agricultor que
                                            haya realizado un pedido, podemos
                                            unificar el envío y los gastos del
                                            mismo.
                                        </p>
                                        <div
                                            class="btn-info-w-alt cursor_pointer"
                                            @click="
                                                sendInfoModal(
                                                    week.weekYear,
                                                    envio.id
                                                )
                                            "
                                            style="color: rgb(0, 113, 188); border-color: rgb(0, 113, 188);"
                                            v-b-modal.modal-share-envio
                                            id="shareEnvio"
                                        >
                                            <span>Compartir envío</span>
                                        </div>
                                    </div>
                                </windows-info>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-9">
                                <span
                                    >Gastos de envio compartidos({{
                                        envio.pedido_compartido.numero_pedido
                                    }})</span
                                >
                            </div>
                            <div class="col-3 content_valores">
                                <span>GRATIS</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <share-ship-cart ref="share-envio"></share-ship-cart>
            <div class="col-12 content_total">
                <div class="row">
                    <div class="col-8">
                        <span>Total (IVA incluido)</span>
                    </div>
                    <div class="col-4 content_valores">
                        <span>{{ cart.total }} €</span>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-3" v-if="step != 1 && step != 2">
                <span
                    class="cart-checkbox-group"
                    :class="{ checked: accepted }"
                    @click="accepted = !accepted"
                >
                    <span class="checkbox"></span>
                    He leído y acepto las
                </span>
                <a
                    :href="route('info.terminos.condiciones')"
                    target="_blank"
                    style="text-decoration: underline; color: #000"
                    >Condiciones de venta.</a
                >
            </div>

            <div v-if="step == '1'" class="col-12 content_button_next">
                <a
                    :href="nextStepUrl"
                    class="button_cart_style_alt"
                >
                    <div>
                        <span>Comenzar pedido</span>
                    </div>
                </a>
                <a href="/" class="btn btn-seguir-comprando">
                    Seguir comprando
                </a>
            </div>
            <div v-else-if="step == '2'" class="col-12 content_button_next">
                <a :href="nextStepUrl" class="button_cart_style_alt">
                    <div>
                        <span>Continuar pedido</span>
                    </div>
                </a>
            </div>
            <div v-else class="col-12 content_button_next">
                <a
                    v-if="!loadButton"
                    @click="goToloadButton()"
                    class="button_cart_style_alt"
                >
                    <div>
                        <span v-if="this.$root.formaPagoSelected == 4"
                            >Continuar</span
                        >
                        <span v-else>Comprar ahora</span>
                    </div>
                </a>
                <load-spiner v-else></load-spiner>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["cart", "nextStepUrl", "step", "linesCompositeByWeeks"],
    data() {
        return {
            loadButton: false,
            accepted: false
        };
    },
    mounted() {},
    computed: {
        totalGastosEnvio() {
            const envios = this.linesCompositeByWeeks.map(line => line.envios);
            console.log(
                `this.linesCompositeByWeeks`,
                this.linesCompositeByWeeks
            );
            console.log(`envios`, envios);
            return envios && envios.length
                ? envios.flat().reduce((total, envio) => {
                      if (envio === undefined) return 0;
                      const costeEnvio = envio.metodo_envio.precio;
                      return total + Number(costeEnvio);
                  }, 0)
                : 0;
        }
    },
    methods: {
        openInfoWindow: function(ventana) {
            var window = this.$refs[ventana][0];
            window.active = !window.active;
        },
        setInstalaciones: function(weekYear, ship) {
            let year = weekYear.substring(0, 4);
            let semana = weekYear.substring(5);
            axios
                .post("/carrito/manage/weeks/shipping/info/edit", {
                    week: semana,
                    year: year,
                    ship_id: ship
                })
                .then(response => {
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                    this.$root.$emit("loadCartInfo");
                    if (this.$parent.$refs["shipBlock-" + weekYear]) {
                        this.$parent.$refs[
                            "shipBlock-" + weekYear
                        ][0].loadInfo();
                    }
                    this.openInfoWindow("gastos_gratis" + weekYear);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        goToloadButton: function() {
            if (this.$root.formaPagoSelected != 4) {
                if (!this.accepted) {
                    alert("Debe aceptar las condiciones de venta");
                    return;
                }
            }
            window.document.getElementById("go_pay_form").submit();
            this.loadButton = !this.loadButton;
        },
        sendInfoModal: function(semana, ship) {
            this.$refs["share-envio"].semana = semana;
            this.$refs["share-envio"].ship_id = ship;
        }
    }
};
</script>

<style scoped>
.cart-checkbox-group {
    cursor: pointer;
}

.cart-checkbox-group span.checkbox {
    padding: 0 8.5px;
    border: 1px solid #333;
    position: relative;
    margin-right: 0.5rem;
}

.cart-checkbox-group:hover span.checkbox:after,
.cart-checkbox-group.checked span.checkbox:after {
    border-color: #c7cf34;
}
</style>

<style>
.cart-checkbox-group:hover span.checkbox:after,
.cart-checkbox-group.checked span.checkbox:after {
    content: "";
    border-left: 5px solid;
    border-bottom: 5px solid;
    position: absolute;
    padding: 4px 10px;
    transform: rotate(-50deg);
    left: 2px;
    bottom: 8px;
}
</style>
